export const defaultTemplate = {
    number: {
        isUnique: true,
        numberrange: "",
    },
    responsiblePerson: {
        option: 'disabled',
    },
    timeSpan: {
        option: 'mandatory',
        autogenerateReturns: true,
    },
    comment: {
        option: 'enabled',
    },
}
export function checkConfigOption(option, value) {
    switch (option) {
        case 'disabled':
            return value === 0 || value === 'disabled'
        case 'enabled':
            return value === 1 || value === 'enabled'
        case 'mandatory':
            return value === 2 || value === 'mandatory'
        default:
            return null
    }
}